import { AxiosError } from "axios";
import { TemplateId } from "../../../globalTypes";
import * as requests from "../../../requests/templates/requestCreators";
import { EwaThunk } from "../../types";
import * as actions from "../actions";
import * as selectors from "../selectors";
import { TemplateMetadataDISPATCH } from "../types";
import { mapApiToDispatch } from "./utils";

const fetchTemplateMetadataForTemplateIds =
  (templateIds: TemplateId[]): EwaThunk =>
  async (dispatch, getState) => {
    const state = getState();

    const isFetching = selectors.getIsMetadataFetchingForTemplateIds(
      state,
      templateIds
    );

    if (isFetching) return;

    dispatch(actions.requestFetchTemplateMetadataBulk(templateIds));

    try {
      const response = await requests.fetchTemplateMetadataBulk(templateIds);
      const templateMetadataBulk = response.data;

      const templateMetadataDispatchBulk: TemplateMetadataDISPATCH[] =
        templateMetadataBulk.map(mapApiToDispatch);

      dispatch(
        actions.successFetchTemplateMetadataBulk(templateMetadataDispatchBulk)
      );
    } catch (e) {
      // error handling
      dispatch(
        actions.errorFetchTemplateMetadataBulk(
          templateIds,
          (e as AxiosError).response
        )
      ); // TODO: nějak to rozparsovat
    }
  };

export default fetchTemplateMetadataForTemplateIds;
